import "./sharedetail.scss";
import { useSharePost } from "./hooks/useSharePost";
import { ShareHeader } from "./components/ShareHeader";
import { ShareInput } from "./components/ShareInput";
import { SharePreviews } from "./components/SharePreviews";
import { ShareActions } from "./components/ShareActions";

const Sharedetail = ({ setOpenModal, handleShare, currentUser }) => {
    const state = useSharePost(handleShare, setOpenModal);
    
    const closeHandler = () => setOpenModal(false);

    return (
        <div className="sharedetail">
            <div className="overplay" onClick={closeHandler}></div>

            <div className="wrapper" onClick={(e) => e.stopPropagation()}>
                <ShareHeader onClose={closeHandler} />

                <div className="center">
                    <ShareInput 
                        currentUser={currentUser}
                        postType={state.postType}
                        setPostType={state.setPostType}
                        desc={state.desc}
                        setDesc={state.setDesc}
                    />

                    <SharePreviews 
                        isFetchingLink={state.isFetchingLink}
                        linkPreview={state.linkPreview}
                        files={state.files}
                        removeFile={state.removeFile}
                    />
                </div>

                <ShareActions 
                    handleFileChange={state.handleFileChange}
                    errorMsg={state.errorMsg}
                    isSubmitting={state.isSubmitting}
                    cooldown={state.cooldown}
                    desc={state.desc}
                    files={state.files}
                    onShareClick={state.onShareClick}
                />
            </div>
        </div>
    );
};

export default Sharedetail;